import { Task } from '@interfaces/ganttTasks/ganttTasks';

import colors from '@constants/colors';
import { portalTasksPriorities } from '@constants/common';

export const getBarColor = (task: Task) => {
	if (task.priority?.name === portalTasksPriorities.high) {
		return colors.pink10;
	} else if (task.priority?.name === portalTasksPriorities.medium) {
		return colors.orange10;
	}

	return colors.green10;
};

export const getBarBorderColor = (task: Task) => {
	if (task.priority?.name === portalTasksPriorities.high) {
		return colors.red50;
	} else if (task.priority?.name === portalTasksPriorities.medium) {
		return colors.orange50;
	}

	return colors.green50;
};
